import "../../assets/stylesheets/application.tailwind.css";

import { createInertiaApp } from "@inertiajs/react";
import { createElement } from "react";
import { createRoot } from "react-dom/client";

const pages = import.meta.glob("../pages/**/*.jsx");

createInertiaApp({
  resolve: async (name) => {
    const module = await pages[`../pages/${name}.jsx`]();
    return module.default;
  },
  setup({ el, App, props }) {
    createRoot(el).render(createElement(App, props));
  },
});
